// extracted by mini-css-extract-plugin
export default {"wrap":"Footer_wrap__sfNWA","socials":"Footer_socials__uJpGo","icon":"Footer_icon__8vaab","menuWrap":"Footer_menuWrap__Ugzzb"};